// @ts-expect-error ts-migrate(7016) FIXME: Could not find a declaration file for module 'vend... Remove this comment to see the full error message
import createStore from 'vendor/cnpm/fluxible.v0-4/addons/createStore';

import ExportState from 'bundles/groups/constants/ExportState';
import ExportUtils from 'bundles/teach-course/lib/ExportUtils';

const ExportStore = createStore({
  storeName: 'ExportStore',

  initialize() {
    this.exportState = '';
    this.metadata = null;
    this.s12nData = null;
    this.courseList = null;
    this.activeCourse = null;
    this.initialExportLoad = true;
  },

  getMetadata() {
    return this.metadata;
  },

  getExportState() {
    return this.exportState;
  },

  getCourseList() {
    return this.courseList;
  },

  getActiveCourse() {
    return this.activeCourse;
  },
});

ExportStore.handlers = {
  S12N_DATA_LOADED({ s12nData, courseList }: $TSFixMe) {
    this.s12nData = s12nData;
    this.courseList = courseList;
    this.emitChange();
  },

  SET_ACTIVE_COURSE({ course }: $TSFixMe) {
    if (course !== this.activeCourse) {
      // reset export data
      this.metadata = null;
    }

    this.activeCourse = course;
    this.emitChange();
  },

  EXPORT_METADATA_LOADED({ metadata }: $TSFixMe) {
    this.metadata = metadata;

    switch (metadata.state) {
      case 'None':
        this.exportState = ExportState.STALE;
        break;

      case 'Created':
      case 'Started':
        this.exportState = ExportState.GENERATING;
        break;

      case 'Completed':
        if (ExportUtils.isLastExportStale(metadata.startedAt, Date.now())) {
          this.exportState = ExportState.STALE;
        } else {
          this.exportState = ExportState.UPDATED;
        }
        break;

      default:
        // If the last export was in a failed state and this is
        // the first time we are loading the state, do not show an
        // error message (design requirement)
        // Set the state to STALE instead, so the next time the export
        // is requested, a new export job is started
        if (!this.initialExportLoad) {
          this.exportState = ExportState.ERROR;
        } else {
          this.exportState = ExportState.STALE;
        }
        break;
    }
    this.emitChange();
  },

  EXPORT_JOB_CREATED() {
    this.exportState = ExportState.GENERATING;
    this.initialExportLoad = false;
    this.emitChange();
  },
};

export default ExportStore;
